module.exports = __webpack_public_path__ + "img/Property 1=4x3, Property 2=CD - DR Congo.659651d8.svg";